import ReferrerContext from "../Contexts/ReferrerContext";

export function withReferrerProvider(comp: JSX.Element, referrer: string) {
  return (
    <ReferrerContext.Provider value={referrer}>{comp}</ReferrerContext.Provider>
  );
}
